// StoresDataStore
export const AllStoresDataStoreSymbol = Symbol('AllStoresDataStoreSymbol')
export const AvailableStoresDataStoreSymbol = Symbol('AvailableStoresDataStoreSymbol')
export const Way4StoresDataStoreSymbol = Symbol('Way4StoresDataStoreSymbol')
